
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/common";
const commonState = namespace("Common");

import { pathwayTypeInfoType } from '@/types/Information';

@Component
export default class StartEfiling extends Vue {

    @informationState.Action
    public UpdatePathType!:(newPathType: pathwayTypeInfoType) => void

    @commonState.Action
    public UpdateUserSelfRepresented!: (newUserSelfRepresented: boolean) => void
   

    startAppeal = false;
    respondToAppeal = false;

    newAppealPressed = false;
    respondAppealPressed = false;
    

    activeVariant = 'outline-primary bg-success text-white';
    inActiveVariant = 'outline-dark bg-secondary text-white';

    public startAppealPath() {
        this.startAppeal = true;
        this.respondToAppeal = false;
        this.switchDisableRow(true);
    }

    public respondToAppealPath() {
        
        this.respondToAppeal = true;
        this.startAppeal = false;
        this.switchDisableRow(false);
    }

    public appRightToAppealPath(selfRep: boolean) {

        this.updateSelfRepresented(selfRep)
        const pathType = {} as pathwayTypeInfoType;
        pathType.appRightToAppeal = true;
        this.UpdatePathType(pathType);

    }

    public updateSelfRepresented(selfRep){
        this.UpdateUserSelfRepresented(selfRep)
        const body = {                            
            represented: !selfRep,
        }
        
        this.$http.put('/user-info/', body)
        .then((response) => {                  
        },(err) => {                   
        });    
    }

    // public appApplyLeavePath() {

    //     const pathType = {} as pathwayTypeInfoType;
    //     pathType.appApplyLeave = true;
    //     this.UpdatePathType(pathType);   

    // }

    public responseToAppealPath(selfRep: boolean) {
        
        this.updateSelfRepresented(selfRep);
        const pathType = {} as pathwayTypeInfoType;
        pathType.rspToAppeal = true;
        this.UpdatePathType(pathType);

    }

    // public responseToLeavePath() {
        
    //     const pathType = {} as pathwayTypeInfoType;
    //     pathType.rspToLeave = true;
    //     this.UpdatePathType(pathType);
        
    // }

    public switchDisableRow(newAppeal: boolean){

        if (newAppeal){
            this.newAppealPressed = true;
            this.respondAppealPressed = false;

        } else {
            this.newAppealPressed = false;
            this.respondAppealPressed = true;
        }

    }    

}

